import { render } from "./ParcoursOMEGA.vue?vue&type=template&id=b7fa38b6&scoped=true&ts=true"
import script from "./ParcoursOMEGA.vue?vue&type=script&lang=ts"
export * from "./ParcoursOMEGA.vue?vue&type=script&lang=ts"

import "./ParcoursOMEGA.vue?vue&type=style&index=0&id=b7fa38b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7fa38b6"]])

export default __exports__